import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-website-article-list',
  templateUrl: './website-article-list.component.html'
})
export class WebsiteArticleListComponent {

  @Input() identifier
  @Input() data
  @Input() module
  @Output() page = new EventEmitter()
  @Output() infiniteScroll = new EventEmitter()

  constructor(
  ) { }

  scrollEvent() {
    this.infiniteScroll.emit()
  }
}
